/**
 * @(#)2019/8/26.
 * YxAction，行为组件，用于处理按钮逻辑 总体控制
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import YxActions from "./YxAction";
import PropTypes from "prop-types";

/**
 *  图标:icon,按钮：button,a标签：link,块标签：tag
 */
const styleType = ["icon", "link", "tag", "button"];

/**
 * action|功能,jump|跳转,back|返回,submit|提交reset|重置, upload|上传, downFile|下载, popup|弹窗
 */
const actionType = [
  "action",
  "jump",
  "back",
  "submit",
  "reset",
  "upload",
  "downFile",
  "popup",
];

const propTypes = {
  // group 组信息，如果需要传入一组，那么将参数用数组的形式传入此字段
  // group: PropTypes.array,
  //注入数据，当为组传入的时候，参数里的chhildren将被注入此数据
  iocData: PropTypes.object,

  //渲染函数，直接渲染自定义节点
  render: PropTypes.any,

  //按钮提示符
  title: PropTypes.any,

  //如果使用了映射值，指定需要匹配枚举映射的字段 ，  如果使用了text，则该字段无效
  dataIndex: PropTypes.string,
  //按钮文字
  text: PropTypes.string,

  //data 数据源,跳转或提交的时候都会直接带上
  data: PropTypes.object,

  //数据模型，用于加工data，参考request的模型功能
  model: PropTypes.object,

  // 数据工厂，同model
  factory: PropTypes.func,

  //请求参数
  requestParam: PropTypes.object,

  //给确认框的参数
  popconfirmParam: PropTypes.object,

  //是否具有确认功能
  isConfirm: PropTypes.bool,

  //path 跳转路径， jump back 生效
  path: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  // 样式类型
  styleType: PropTypes.oneOf(styleType),

  // 按钮类型：
  actionType: PropTypes.oneOf(actionType),

  //当 actionType 为 submit时起效，defaul 默认/ scroll 自动滚动进可见范围
  validateModel: PropTypes.oneOf(["defaul", "scroll"]),

  //actionType = jump 时起效，iframe:跳转新页面，router：路由跳转，blank：打开新窗口
  jumpType: PropTypes.oneOf(["iframe", "router", "blank"]),

  //actionType为popup时 ，会给popupParam.children抛出一个close函数，
  //可以在外部主动关闭弹窗 ,popupParam:{children(data,{close}){}}
  popupParam: PropTypes.object,

  //是否开启组件参数校验
  check: PropTypes.bool,

  // 下载配置参数
  downConfig: PropTypes.object,

  //上传参数
  uploadConfig: PropTypes.object,

  //  提示语如果要关闭，给message设置为false
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),

  // 自己组件定义额外的类型
  extraTypeList: PropTypes.array,

  // 延时更新state，默认300ms
  timeOut: PropTypes.number,

  //  *当 actionType 为 submit时起效,校验通过的回调函数,抛出 ids,values 两参数
  validateCallback: PropTypes.func,

  // 点击之前的回调 如果该函数返回false，则action的操作和提交都不会执行
  beforeClick: PropTypes.func,

  // 点击事件之后的回调
  afterClick: PropTypes.func,

  //当 actionType 为 submit时起效,要校验或提交的的控件的id组，比如['id1','id2']
  ids: PropTypes.array,

  // 验证配置，参考 antd from
  validateOptions: PropTypes.object,

  // 分组时，是否收起折叠
  packUp: PropTypes.bool,
};

YxActions.propTypes = {
  // group: PropTypes.arrayOf(propTypes),
  group: PropTypes.arrayOf(PropTypes.shape(propTypes)),
  ...propTypes,
};

YxActions.defaultProps = {
  text: null,
  emum: null,
  data: null,
  path: null,
  title: null,
  timeOut: 60,
  message: "",
  titps: null,
  render: null,
  version: null,
  isConfirm: null,
  requestParam: null,
  popconfirmParam: {},
  styleType: "button",
  validateModel: null,
  actionType: "action",
  packUp: false, // 是否收入到收起按钮
  validateOptions: undefined,
  validateCallback: function () {},
};

export default YxActions;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxAction/index.js